/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vcG1zL3Byb2plY3QtZGV0YWlscy9wcm9qZWN0LWRlbGl2ZXJ5L2RlbGl2ZXJ5LWVtYWlsLXRlbXBsYXRlL2RlbGl2ZXJ5LWVtYWlsLXRlbXBsYXRlLmNvbXBvbmVudC5zY3NzIn0= */"];
export { styles as styles };
